import { useCallback } from 'react';
import { useController } from 'react-hook-form';
import type {
    FieldPath,
    FieldValues,
    UseControllerProps,
    UseControllerReturn,
} from 'react-hook-form';

export const useFieldController = <
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
    controllerProps: UseControllerProps<TFieldValues, TName>,
    onChangeCallback?: (...event: Parameters<UseControllerReturn<TFieldValues, TName>['field']['onChange']>) => void
) => {
    const controller = useController<TFieldValues, TName>(controllerProps);

    const changeHandler = useCallback(
        (
            ...event: Parameters<
                UseControllerReturn<TFieldValues, TName>['field']['onChange']
            >
        ) => {
            controller.field.onChange(...event);
            onChangeCallback?.(...event);
        },
        [controller.field, onChangeCallback]
    );

    return {
        ...controller,
        field: {
            ...controller.field,
            onChange: changeHandler,
        },
    };
};
